import { render, staticRenderFns } from "./RecomResalesStocks.vue?vue&type=template&id=4b4062e8"
import script from "./RecomResalesStocks.vue?vue&type=script&lang=js"
export * from "./RecomResalesStocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports